import React, { useEffect, useState } from "react";
import { Form, Button, Alert, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import * as inventoryService from "../../services/inventoryService";
import CategoriesSection from "./CategoriesSection";
import InventorySetupSections from "./stock/InventorySetupSections";

function InventorySettings() {
  const [settings, setSettings] = useState(null);
  const [costingMethod, setCostingMethod] = useState("WAC");
  const [markupPct, setMarkupPct] = useState(0);
  const [saving, setSaving] = useState(false);
  const [methodChanged, setMethodChanged] = useState(false);

  useEffect(() => {
    inventoryService.getSettings().then((res) => {
      setSettings(res?.data || null);
      setCostingMethod(res?.data?.costing_method || "WAC");
      setMarkupPct(res?.data?.default_markup_pct || 0);
    });
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await inventoryService.updateSettings({
        costing_method: costingMethod,
        default_markup_pct: Number(markupPct),
      });
      if (res?.success === false) {
        toast.error(res.message || "Could not save settings");
      } else {
        toast.success("Inventory settings updated");
        setMethodChanged(false);
      }
    } catch (err) {
      toast.error(err.message || "Could not save settings");
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return <div className="p-4">Loading…</div>;

  return (
    <div className="p-3" style={{ maxWidth: 1040 }}>
      <div style={{ maxWidth: 520 }}>
      <h4 className="mb-3">Inventory Settings</h4>
      <Card body>
        <Form onSubmit={handleSave}>
          <Form.Group className="mb-3">
            <Form.Label>Costing method</Form.Label>
            <Form.Select
              className="inventory-select"
              value={costingMethod}
              onChange={(e) => {
                setCostingMethod(e.target.value);
                setMethodChanged(e.target.value !== settings.costing_method);
              }}
            >
              <option value="WAC">Weighted Average Cost (WAC)</option>
              <option value="LATEST">Latest purchase cost</option>
            </Form.Select>
            <Form.Text className="text-muted">
              WAC recalculates a running average cost on every stock-in. LATEST always uses the most recent
              purchase cost.
            </Form.Text>
          </Form.Group>

          {methodChanged && (
            <Alert variant="warning">
              Changing the costing method affects valuation and margin reports <strong>going forward only</strong> —
              past transactions keep the unit cost they were recorded with.
            </Alert>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Default markup %</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              min="0"
              value={markupPct}
              onChange={(e) => setMarkupPct(e.target.value)}
            />
            <Form.Text className="text-muted">
              Used to suggest a selling price (cost × (1 + markup%)) on the item form and when a booking part has no
              selling price set. Always editable, never enforced.
            </Form.Text>
          </Form.Group>

          <Button type="submit" disabled={saving} style={{ background: "var(--button-color)", border: "none", color: "#fff" }}>
            {saving ? "Saving…" : "Save Settings"}
          </Button>
        </Form>
      </Card>

      <Card body className="mt-4">
        <CategoriesSection />
      </Card>
      </div>

      <InventorySetupSections />
    </div>
  );
}

export default InventorySettings;
